/* ==========================================================
   FDV Shopify Theme — Main JavaScript
   Handles: mobile navigation, language switching, gallery,
   product filtering (catalog), thumbnail swapper (PDP),
   search overlay.
   No external dependencies — vanilla JS.
   ========================================================== */
(function () {
  'use strict';

  /* ---- Mobile Navigation ---------------------------------- */
  var toggle = document.getElementById('navToggle');
  var menu   = document.getElementById('mobileMenu');
  var backdrop = document.getElementById('mobileBackdrop');

  function openNav() {
    document.body.classList.add('nav-open', 'nav-locked');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (menu)   menu.setAttribute('aria-hidden', 'false');
  }

  function closeNav() {
    document.body.classList.remove('nav-open', 'nav-locked');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (menu)   menu.setAttribute('aria-hidden', 'true');
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      var isOpen = document.body.classList.contains('nav-open');
      isOpen ? closeNav() : openNav();
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', closeNav);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeNav(); fdvCloseSearch(); }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 860) closeNav();
  });

  /* ---- Language Switching --------------------------------- */
  /* Shopify Markets: redirect to locale-prefixed URL.
     Falls back to a session-cookie approach for single-market stores. */
  window.fdvSetLocale = function (locale) {
    var current = document.documentElement.lang || 'en';
    if (locale === current) return;

    /* Shopify Markets URL convention: /es/... for Spanish */
    var path = window.location.pathname;
    var search = window.location.search;

    /* Strip existing locale prefix if any */
    var localePattern = /^\/(en|es)(\/|$)/;
    var cleanPath = path.replace(localePattern, '/');

    if (locale !== 'en') {
      window.location.href = '/' + locale + cleanPath + search;
    } else {
      window.location.href = cleanPath + search;
    }
  };

  /* ---- PDP Thumbnail Switcher ----------------------------- */
  var thumbs = document.querySelectorAll('.pdp-thumb');
  var mainImg = document.querySelector('.pdp-main img');

  if (thumbs.length && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = thumb.querySelector('img');
        if (!img) return;
        /* Use data-full for the high-res version rendered by Liquid */
        var fullSrc = img.getAttribute('data-full') || img.src;
        mainImg.src = fullSrc;
        mainImg.srcset = '';
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
    /* Activate first thumb on load */
    if (thumbs[0]) thumbs[0].classList.add('is-active');
  }

  /* ---- Catalog PLP Filter + Sort -------------------------- */
  var grid    = document.getElementById('plpGrid');
  var countEl = document.getElementById('plpCount');
  var emptyEl = document.getElementById('plpEmpty');
  var sortSel = document.getElementById('plpSort');
  var chips   = document.querySelectorAll('.plp-filters .chip');
  var current = 'all';

  if (grid && chips.length) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.pcard'));
    var validFilters = Array.prototype.map.call(chips, function (c) { return c.dataset.filter; });

    function setActive(filter) {
      current = filter;
      chips.forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.filter === filter);
      });
    }

    function render() {
      var arr = cards.slice();
      if (sortSel && sortSel.value === 'az') {
        arr.sort(function (a, b) {
          var aName = a.querySelector('.pl-name');
          var bName = b.querySelector('.pl-name');
          return (aName ? aName.textContent.trim() : '').localeCompare(bName ? bName.textContent.trim() : '');
        });
      } else {
        arr.sort(function (a, b) { return (+a.dataset.order) - (+b.dataset.order); });
      }
      arr.forEach(function (c) { grid.appendChild(c); });

      var shown = 0;
      arr.forEach(function (c) {
        var ok = current === 'all' || c.dataset.cat === current;
        c.style.display = ok ? '' : 'none';
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown;
      if (emptyEl) emptyEl.style.display = shown ? 'none' : 'block';
    }

    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        setActive(ch.dataset.filter);
        if (history.replaceState) {
          history.replaceState(null, '', ch.dataset.filter === 'all'
            ? location.pathname
            : '#' + ch.dataset.filter);
        }
        render();
      });
    });

    if (sortSel) sortSel.addEventListener('change', render);

    /* Deep-link: /collections/all#cooktops pre-selects filter */
    var hash = (location.hash || '').replace('#', '');
    if (validFilters.indexOf(hash) !== -1) setActive(hash);
    render();
  }

  /* ---- Search Overlay ------------------------------------ */
  var searchOverlay = document.getElementById('searchOverlay');
  var searchInputEl = document.getElementById('searchInput');
  var searchClose   = document.getElementById('searchClose');

  function fdvCloseSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open');
  }

  window.fdvOpenSearch = function () {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open');
    if (searchInputEl) { searchInputEl.value = ''; searchInputEl.focus(); }
  };

  if (searchClose) searchClose.addEventListener('click', fdvCloseSearch);

  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) fdvCloseSearch();
    });
  }

})();
